export function ConveyancerTermsOfService() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6">
      <h1 className="mb-8 text-3xl font-bold tracking-tight">Terms of Service</h1>
      <p className="mb-4 text-sm text-gray-500">Last updated: June 2026</p>

      <section className="space-y-6 text-gray-700 dark:text-gray-300 [&_h2]:mb-2 [&_h2]:mt-8 [&_h2]:text-xl [&_h2]:font-semibold [&_ul]:ml-6 [&_ul]:list-disc [&_ul]:space-y-1">
        <p>
          These Terms of Service (&ldquo;Terms&rdquo;) govern your use of the
          BidConvey conveyancing appointment platform operated by BidConvey
          (Pty) Ltd (&ldquo;we&rdquo;, &ldquo;us&rdquo;, &ldquo;our&rdquo;). By
          creating an account or using the platform you agree to these Terms.
        </p>

        <h2>1. Platform Overview</h2>
        <p>
          BidConvey is a marketplace that connects property buyers and sellers
          with registered conveyancers through a competitive sealed-bid
          process. We do not provide legal or conveyancing services ourselves.
        </p>

        <h2>2. Eligibility</h2>
        <ul>
          <li>Conveyancers must be a valid Legal Practice Council (LPC) member.</li>
          <li>A Conveyancer must hold a valid Fidelity Fund Certificate.</li>
          <li>You must be an accredited South African Conveyancer.</li>
          <li>
            You must provide accurate and complete information at registration.
            All information must be updated as and when any change occurs.
          </li>
        </ul>

        <h2>3. User Accounts</h2>
        <ul>
          <li>You are responsible for maintaining the confidentiality of your login credentials.</li>
          <li>You must notify us immediately of any unauthorised use of your account.</li>
          <li>We reserve the right to suspend or terminate accounts that violate these Terms.</li>
        </ul>

        <h2>4. The Bidding Process</h2>
        <ul>
          <li>All bids are sealed — conveyancers cannot see other conveyancers&apos; bids during the bidding window.</li>
          <li>The bidding window is 24 business hours (Mon&ndash;Fri 09:00&ndash;17:00 SAST, excluding public holidays).</li>
          <li>A minimum of 5 bids is required before bidding can close.</li>
          <li>Discount percentages, if any, must range between 0% and 75%.</li>
          <li>
            Any discount must be honoured for a period of 30 (Thirty) ordinary
            days from date of acceptance of your bid. Should the conveyancing
            tariff change during this period, but before a statement of account
            is presented to the buyer, you shall be entitled to adjust your
            account accordingly.
          </li>
          <li>You must inform the buyer, in writing of the change in the tariff.</li>
          <li>Any discount provided shall equally apply to any notarial deed linked to the transfer bid.</li>
        </ul>

        <h2>5. Joint Appointment</h2>
        <p>
          Where the buyer elects &ldquo;jointly&rdquo; with a seller, the
          seller reviews anonymised service offerings (without pricing) and
          selects their top 3 choices. The buyer then makes the final selection
          from those 3.
        </p>

        <h2>6. Privacy</h2>
        <p>
          Your use of BidConvey is also governed by our{" "}
          <a href="/privacy" className="underline font-medium">Privacy Policy</a>{" "}
          and our Code of Conduct, which explain how we collect, use, and
          protect your personal information in accordance with POPIA.
        </p>

        <h2>7. Intellectual Property</h2>
        <p>
          All content, design, and software on the platform is owned by
          BidConvey (Pty) Ltd or its licensors. You may not copy, reproduce, or
          distribute any part of the platform without written permission.
        </p>

        <h2>8. Limitation of Liability</h2>
        <p>
          BidConvey is a marketplace facilitator. We do not guarantee the
          quality or outcome of conveyancing services. To the fullest extent
          permitted by law, we are not liable for indirect, incidental, or
          consequential damages arising from your use of the platform or the
          service that you provide. This responsibility remains completely
          within your domain.
        </p>

        <h2>9. Dispute Resolution</h2>
        <p>
          Any disputes arising from these Terms shall be governed by the laws of
          the Republic of South Africa and resolved in the courts of South
          Africa.
        </p>

        <h2>10. Changes to Terms</h2>
        <p>
          We may update these Terms from time to time. The &ldquo;Last
          updated&rdquo; date at the top indicates when they were last revised.
          Continued use constitutes acceptance.
        </p>

        <h2>11. Contact</h2>
        <p>
          BidConvey (Pty) Ltd<br />
          Email:{" "}
          <a href="mailto:support@bidconvey.co.za" className="underline font-medium">
            support@bidconvey.co.za
          </a>
        </p>
      </section>

      <div className="mt-12">
        <a href="/" className="text-sm font-medium text-blue-600 hover:underline">
          &larr; Back to home
        </a>
      </div>
    </div>
  );
}
